/**
 * Task state constants for Partner Manager workflow
 */
export const TASK_STATES = {
    // Draft Phase
    NEW: 'NEW', //coming directly from poller
    DRAFT_CREATED: 'DRAFT_CREATED', // Data created
    DRAFT_FAILED: 'DRAFT_FAILED', // Data creation failed, needs attention
    DRAFT_APPROVED: 'DRAFT_APPROVED', // Approved by human, ready for staging setups creation
    DRAFT_COMPLETED: 'DRAFT_COMPLETED', // Generated by service, ready for staging setup

    // Staging Phase
    STAGING_RUNNING: 'STAGING_RUNNING', // Staging setup started (envelopes creation in progress - staging)
    STAGING_COMPLETED: 'STAGING_COMPLETED', // Staging setup done, ready for test execution
    STAGING_FAILED: 'STAGING_FAILED', // Staging setup failed, needs attention

    // Test Phase
    TEST_RUNNING: 'TEST_RUNNING',  // Staging setup done, ready for test execution
    TEST_FAILED: 'TEST_FAILED', // Staging test failed, needs attention
    TEST_COMPLETED: 'TEST_COMPLETED', // Test completed successfully

    // Release Phase
    RELEASE_APPROVED: 'RELEASE_APPROVED', // Ready for release, approved by human
    RELEASE_RUNNING: 'RELEASE_RUNNING', // Release in progress (envelopes creation in progress - release)
    RELEASE_COMPLETED: 'RELEASE_COMPLETED', // Release completed successfully
    RELEASE_FAILED: 'RELEASE_FAILED', // Release failed, needs attention
} as const;

/**
 * Transaction code descriptions
 */
export const TRANSACTION_DESCRIPTIONS: Record<number, string> = {
    810: 'Invoice / INVOIC',
    820: 'EFT / Remittance Advice / REMADV',
    824: 'Application Advice',
    830: 'Scheduling Agreements / DELFOR',
    850: 'Purchase Orders / ORDERS',
    855: 'PO Acknowledgment / ORDRSP',
    856: 'Advance Ship Notice / DESADV',
    861: 'Receiving Advice',
    862: 'Ship Schedule / DELJIT',
    997: 'Functional Acknowledgment',
};